import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { isTokenExpired } from '../../utils/tokenUtils';

const URL_LOGIN = process.env.REACT_APP_URL_LOGIN;
const URL_API = process.env.REACT_APP_BASE_API_URL;

const AccessGate = ({ children }) => {
    const [searchParams] = useSearchParams();
    const [isAuthorized, setIsAuthorized] = useState(null); // null = cargando
    const hasValidated = useRef(false);

    const validateKey = async (keyFromUrl) => {
        
        try {
            const { data } = await axios.post(`${URL_API}/login`, { key: keyFromUrl });

            if (data.success && data.token) {

                // Guardar token en sessionStorage
                sessionStorage.setItem('ebt_token_fmcsa', data.token);
                sessionStorage.setItem('ebt_user_fmcsa', data.payload.idUser);
                sessionStorage.setItem('ebt_name_fmcsa', data.payload.nombre);

                // Elimina la key de la url
                window.history.replaceState(null, '', window.location.pathname);

                setIsAuthorized(true);
            } else {
                window.location.href = URL_LOGIN;
            }
        } catch (error) {
            console.error("Error en la validación de la clave", error);
            Swal.fire({
                title: 'Error',
                text: 'No se pudo validar la clave',
                icon: 'error',
                confirmButtonText: 'Aceptar',
            }).then(() => window.location.href = URL_LOGIN);
        }
        
    };

    useEffect(() => {
        if (hasValidated.current) return;
        hasValidated.current = true;

        const keyFromUrl = searchParams.get('key');
        const ebtToken = sessionStorage.getItem('ebt_token_fmcsa');

        if (keyFromUrl) {
            validateKey(keyFromUrl);
            return;
        }

        if (ebtToken && !isTokenExpired(ebtToken)) {
            setIsAuthorized(true);
            return;
        }

        sessionStorage.removeItem('ebt_token_fmcsa');
        window.location.href = URL_LOGIN;
    }, [searchParams]);

    if (isAuthorized === null) {
        return <div style={{ textAlign: 'center', marginTop: 40 }}>Validando acceso...</div>;
    }

    return <>{children}</>;
};

export default AccessGate;